
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from "emailjs-com";

const ManageUser = ({ userData }) => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showPanConfirm, setShowPanConfirm] = useState(false);
  const [showAadhaarConfirm, setShowAadhaarConfirm] = useState(false);
const [showCard, setShowCard] = useState(true);


  const formRef = useRef();
  const userId = userData?.id ?? null;

  // ================= FETCH USERS =================
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await axios.get("https://api.bigfresh.in/userdetail");
        const allUsers = res.data.data || [];
        setUsers(allUsers.filter((u) => u.id !== userId));

      } catch (err) {
        toast.error("Failed to fetch users", { position: "top-center" });
      }
    };
    fetchUsers();
  }, [userId]);

  // ================= SEARCH =================
  const filteredUsers = users.filter(
    (u) =>
      u.user_id?.toString().includes(searchTerm) ||
      u.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ================= EMAIL =================
  const sendEmail = (e) => {
    e.preventDefault();

    if (!selectedUser?.email) {
      toast.error("User email not found", { position: "top-center" });
      return;
    }

    const templateParams = {
      name: selectedUser.name,
      user_id: selectedUser.user_id,
      email: selectedUser.email,
      pass: selectedUser.password,
    };

    emailjs
      .send(
        "service_mart",
        "template_details",
        templateParams,
        "5lDOFVkoUPR1_6_fI"
      )
      .then(
        () => toast.success("Email sent successfully!", { position: "top-center" }),
        () => toast.error("Failed to send email", { position: "top-center" })
      );
  };

  // ================= VERIFY PAN =================
  const handleVerifyPan = async () => {
    try {
      await axios.post("https://api.bigfresh.in/pan-verify", {
        user_id: selectedUser.user_id,
      });

      toast.success("PAN verified", { position: "top-center" });

      setSelectedUser((prev) => ({
        ...prev,
        pan_verify: "Verified",
      }));

      setShowPanConfirm(false);
    } catch (error) {
      toast.error("PAN verification failed", { position: "top-center" });
    }
  };

  // ================= VERIFY AADHAAR =================
  const handleVerifyAadhaar = async () => {
    try {
      await axios.post("https://api.bigfresh.in/aadhaar-verify", {
        user_id: selectedUser.user_id,
      });

      toast.success("Aadhaar verified", { position: "top-center" });

      setSelectedUser((prev) => ({
        ...prev,
        aadhaar_verify: "Verified",
      }));

      setShowAadhaarConfirm(false);
    } catch (error) {
      toast.error("Aadhaar verification failed", { position: "top-center" });
    }
  };

  

  return (
    <div className="container my-4">
      <ToastContainer />
 <h3 className="text-center  mb-4 text-success fw-bold">Manage Users</h3>
      {/* SEARCH */}
      <input
        className="form-control w-50 mb-3"
        placeholder="Search by User ID or Name"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {/* USER TABLE */}
      <table className="table table-bordered table-hover">
        <thead className="table-dark">
          <tr>
            <th>User ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Password</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsers.map((u) => (
            <tr key={u.id}>
              <td>{u.user_id}</td>
              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.password}</td>
              <td>
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => setSelectedUser(u)}
                >
                  View Detail
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* ================= DETAIL PANEL ================= */}


      {showCard && selectedUser && (
   <div className="card shadow-lg p-4 mt-4 border-0 position-relative">

     <button
      type="button"
      className="btn-close position-absolute top-0 end-0 m-3"
      aria-label="Close"
     onClick={() => setSelectedUser(null)} 
    ></button>
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="fw-bold">{selectedUser.name}</h3>
            <span className="text-muted mt-5">ID: {selectedUser.user_id}</span>
          </div>
          <p className="text-secondary mb-3">
            {selectedUser.email} &nbsp; | &nbsp; {selectedUser.phone}
          </p>

          {/* Aadhaar Section */}
          <div className="mb-4">
            <div className="d-flex align-items-center mb-2">
              <h5 className="me-3">Aadhaar</h5>
              <span
                className={`badge ${
                  selectedUser.aadhaar_verify === "Verified"
                    ? "bg-success"
                    : "bg-warning text-dark"
                }`}
              >
                {selectedUser.aadhaar_verify === "Verified"
                  ? "Verified"
                  : "Not Verified"}
              </span>
              <button
                className="btn btn-sm btn-outline-primary ms-2"
                disabled={selectedUser.aadhaar_verify === "Verified"}
                data-bs-toggle="modal"
                data-bs-target="#aadhaarModal"
              >
                Verify Now
              </button>
            </div>

           <div className="d-flex justify-content-start gap-3">
  <div className="text-start">
    <p className="mb-1 fw-semibold">Front</p>
    {selectedUser.front ? (
      <img
        src={`https://api.bigfresh.in/uploads/${selectedUser.front}`}
        alt="Aadhaar Front"
        className="img-fluid rounded shadow-sm border"
        style={{ maxHeight: "180px" }}
      />
    ) : (
      <div className="text-danger fst-italic">Image not added</div>
    )}
  </div>

  <div className="text-start">
    <p className="mb-1 fw-semibold">Back</p>
    {selectedUser.back ? (
      <img
        src={`https://api.bigfresh.in/uploads/${selectedUser.back}`}
        alt="Aadhaar Back"
        className="img-fluid rounded shadow-sm border"
        style={{ maxHeight: "180px" }}
      />
    ) : (
      <div className="text-danger fst-italic">Image not added</div>
    )}
  </div>
</div>

          </div>

          {/* PAN Section */}
          <div className="mb-4">
            <div className="d-flex align-items-center mb-2">
              <h5 className="me-3">PAN</h5>
              <span
                className={`badge ${
                  selectedUser.pan_verify === "Verified"
                    ? "bg-success"
                    : "bg-info text-white"
                }`}
              >
                {selectedUser.pan_verify === "Verified"
                  ? "Verified"
                  : "Not Verified"}
              </span>
              <button
                className="btn btn-sm btn-outline-primary ms-2"
                disabled={selectedUser.pan_verify === "Verified"}
                data-bs-toggle="modal"
                data-bs-target="#panModal"
              >
                Verify Now
              </button>
            </div>

            <div className="text-start">
              {selectedUser.pan_img ? (
                <img
                  src={`https://api.bigfresh.in/uploads/${selectedUser.pan_img}`}
                  alt="PAN Card"
                  className="img-fluid rounded shadow-sm border"
                  style={{ maxHeight: "200px" }}
                />
              ) : (
                <div className="text-danger fst-italic">Image not added</div>
              )}
            </div>
          </div>

          {/* Email Section */}
          <form ref={formRef} onSubmit={sendEmail} className="mt-4">
            <h5 className="mb-3">Send Credentials</h5>
            <div className="row g-3">
              <div className="col-md-6">
                <input
                  className="form-control"
                  value={selectedUser.email}
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <input
                  className="form-control"
                  value={selectedUser.password}
                  readOnly
                />
              </div>
            </div>
               <div className="row">
                <div className="col-auto">
                  <button type="submit" className="btn btn-success mt-3 w-100">
              Send Email
            </button>
                </div>
              </div>

         
          </form>
        </div>
)}


      {/* ================= AADHAAR MODAL ================= */}
      <div
        className="modal fade"
        id="aadhaarModal"
        tabIndex="-1"
        aria-labelledby="aadhaarModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="aadhaarModalLabel">
                Verify Aadhaar
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">Are you sure to verify Aadhaar?</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={handleVerifyAadhaar}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ================= PAN MODAL ================= */}
      <div
        className="modal fade"
        id="panModal"
        tabIndex="-1"
        aria-labelledby="panModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="panModalLabel">
                Verify PAN
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">Are you sure to verify PAN?</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={handleVerifyPan}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageUser;



